<template>
  <div>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="CENTRO DE COSTO" key="1">
          <g-master name="forms"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    modalWidth="90%"
                    ref="master"
                    @params="paramsTable"
          >
            <template slot="customButton">
              <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
            </template>
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('PERSONALIZACION_CENTRO_COSTO_ID_UNIDAD')">
                    <a-input
                      v-decorator="['unit_id', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('PERSONALIZACION_CENTRO_COSTO_UNIDAD')">
                    <a-input
                      v-decorator="['unit_name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('PERSONALIZACION_CENTRO_COSTO_ID_SEGMENTO')">
                    <a-input
                      v-decorator="['segment_id', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('PERSONALIZACION_CENTRO_COSTO_SEGMENTO')">
                    <a-input
                      v-decorator="['segment_name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('PERSONALIZACION_CENTRO_COSTO_ID_CENTRO_DE_COSTOS')">
                    <a-input
                      v-decorator="['cc_id', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('PERSONALIZACION_CENTRO_COSTO_CENTRO_DE_COSTOS')">
                    <a-input
                      v-decorator="['cc_name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('PERSONALIZACION_CENTRO_COSTO_ID_PROYECTO')">
                    <a-input
                      v-decorator="['prj_id', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('PrjName')">
                    <a-input
                      v-decorator="['prj_name', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Fecha inicio')" v-bind="fiOptions">
                    <a-date-picker style="width: 100%"
                                   v-decorator="['ini', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Fecha fin')" v-bind="fiOptions">
                    <a-date-picker style="width: 100%"
                                   v-decorator="['end', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
                  </a-form-item>
                </a-col>

                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              :label="$t('Estado')"
                              :formItemConfig="fiOptions"
                              :decorator="['cc_est', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                              :params="cc_est">
                  </g-dropdown>
                </a-col>
              </a-row>
            </template>
          </g-master>
          <a-tabs defaultActiveKey="1">
            <a-tab-pane tab="OFICINAS" key="1">
              <cc-offices v-if="idCc" :id_cc="idCc"></cc-offices>
              <span v-else>Seleccione un centro de costo para ver más.</span>
            </a-tab-pane>
            <a-tab-pane tab="CARGOS" key="2">
              <cc-jobs v-if="idCc" :id_cc="idCc"/>
              <span v-else>Seleccione un centro de costo para ver más.</span>
            </a-tab-pane>
          </a-tabs>
        </a-tab-pane>
      </a-tabs>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        paramsT: {},
        endpointExcel: 'centro_costo_/downloadExcel',
        fileNameExcel: 'CentrosDeCosto',
        tipo_formulario: {
          h_lookup_type: 'FORMS_TYPE'
        },
        cc_est: {
          h_lookup_type: 'ESTADO_ACT_INA',
          use_code: true
        },
        visible: false,
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'cc',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: this.$t('PERSONALIZACION_CENTRO_COSTO_ID_UNIDAD'), dataIndex: 'unit_id', sorter: true},
              {title: this.$t('PERSONALIZACION_CENTRO_COSTO_UNIDAD'), dataIndex: 'unit_name', sorter: true},
              {title: this.$t('PERSONALIZACION_CENTRO_COSTO_ID_SEGMENTO'), dataIndex: 'segment_id', sorter: true},
              {title: this.$t('PERSONALIZACION_CENTRO_COSTO_SEGMENTO'), dataIndex: 'segment_name', sorter: true},
              {title: 'Código Centro de Costo', dataIndex: 'cc_id', sorter: true},
              {title: this.$t('PERSONALIZACION_CENTRO_COSTO_CENTRO_DE_COSTOS'), dataIndex: 'cc_name', sorter: true},
              {title: this.$t('PERSONALIZACION_CENTRO_COSTO_ID_PROYECTO'), dataIndex: 'prj_id', sorter: true},
              {title: this.$t('PERSONALIZACION_CENTRO_COSTO_PROYECTO'), dataIndex: 'prj_name', sorter: true},
              {title: 'Fecha inicio', dataIndex: 'ini', sorter: true},
              {title: 'Fecha fin', dataIndex: 'end', sorter: true},
              {title: 'Estado', dataIndex: 'cc_est', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'cc_est'},
            {name: 'cc_id'},
            {name: 'cc_name'},
            {name: 'end', type: 'date'},
            {name: 'ini', type: 'date'},
            {name: 'prj_id'},
            {name: 'prj_name'},
            {name: 'segment_id'},
            {name: 'segment_name'},
            {name: 'unit_id'},
            {name: 'unit_name'}
          ]
        }
      }
    },
    methods: {
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      idCc () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id : null
      },
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns, centro_costo_completo: true}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Cc/Cc.vue